import LoadingButton from '@mui/lab/LoadingButton';
import { useStyles } from './styles';
import { IBasicButtonProps } from './interfaces';
import { SxProps } from '@mui/material';

const BasicButton = ({
  children,
  primary = false,
  white = false,
  disabled = false,
  loading = false,
  compact = false, // usually used on overlays for example on the share camera for mobile
  onClick,
  sx = {},
  dataTestId
}: IBasicButtonProps) => {
  const classes = useStyles(primary, white, compact);

  return (
    <LoadingButton
      sx={{ ...classes.root, ...sx } as SxProps}
      variant={primary ? 'contained' : 'outlined'}
      disableElevation
      disabled={disabled}
      loading={loading}
      disableRipple
      onClick={onClick}
      data-testid={dataTestId}
    >
      {children}
    </LoadingButton>
  );
};

export default BasicButton;
